import React, { isValidElement } from 'react';

import { HeaderSlots } from './HeaderSlots';
import type { RootHeaderProps } from './types';

const initialSlots = {
  address: null,
  mainShopCategories: null,
  navigation: null,
} as const;

/**
 * Extracts the slots from the children and allows them to be used in the component
 * @param children
 * @returns The slots object with the address, mainShopCategories, and navigation slots
 */
export const useHeaderSlots = (children: RootHeaderProps['children']) => {
  const slots = React.Children.toArray(children).reduce<
    Record<keyof typeof initialSlots, React.ReactNode>
  >((acc, child) => {
    if (isValidElement(child)) {
      if (child.type === HeaderSlots.Address) acc.address = child;
      if (child.type === HeaderSlots.MainShopCategories)
        acc.mainShopCategories = child;
      if (child.type === HeaderSlots.Navigation) acc.navigation = child;
    }
    return acc;
  }, initialSlots);

  return slots;
};
